<script setup>
import Alert from '@/components/common/Alert.vue';
</script>
<template>
	<v-dialog
		v-model="message_flg"
		width="500px"
	>
		<v-toolbar
			tile
			flat
			height = "50px"
			color="#E13533"
			dark
		>
				<v-spacer></v-spacer>
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
					<v-icon
						v-on="on"
						v-bind="attrs"
						class="mr-3"
						@click="message_flg=false"
						small
					>
						mdi-close
					</v-icon>
					</template>
					<span>閉じる</span>
				</v-tooltip>
		</v-toolbar>
		<v-card
			tile
			min-height="100px"
		>
			<!--v-card-title class="py-2"><h2>{{ title }}</h2></v-card-title>
			<v-card-text class="pt-5">
				<span v-html="message"></span>
			</v-card-text-->
			<v-card-text class="px-1 py-0">
				<Alert
					:message="message"
					:messagetitle="title"
					messagetype="1"
					blockheight="150px"
				/>
			</v-card-text>
			<v-card-actions
				class="pb-3 pt-0"
			>
				<v-spacer></v-spacer>
				<v-btn
					@click="yes"
					dark
					color="#E13533"
				>
					はい
				</v-btn>
				<v-btn
					dark
					color="#E13533"
					@click="cancel"
				>
					いいえ
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
export default{
	props : ["message","title"],
    data: () => ({
		message_flg : false,
    }),
	methods : {
		opendl : function(){
			this.message_flg=true;
		},
		yes : function(){
			this.$emit("messreturn");
			this.message_flg=false;
		},
		cancel : function(){
			this.$emit("messcancel");
			this.message_flg=false;
		},
	},
}
</script>
